import React from "react"
import { motion } from 'framer-motion'
import loginSide from '../../Assets/Images/loginSide.png'
import FieldInput from '../../Components/FieldInput'
import * as Yup from 'yup'
import { useFormik } from "formik"
import Button from "../../Components/Button"
import { FiLogIn } from "react-icons/fi";
import { useHistory } from "react-router-dom"
import API from "../../Common/API"
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import { setLoggedIn, setToken, setUserDetails } from "../../Store/Auth/actions"
import { jwtDecode } from 'jwt-decode';
import logo from '../../Assets/Images/logo.png'
import { useTranslation } from "react-i18next"
import TopBar from "../LandingPages/TopBar"

const initialLoginForm = {
    userName: '',
    password: ''
}

const Login = () => {


    const history = useHistory()
    const dispatch = useDispatch();
    const { t } = useTranslation()

    const loginFormSchema = Yup.object().shape({
        userName: Yup.string().required("User name is required"),
        password: Yup.string().required("Password is required")
    })

    const loginForm = useFormik({
        initialValues: initialLoginForm,
        validateOnMount: true,
        validationSchema: loginFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            try {
                API.post('/auth/login', values).then((apiRes) => {
                    if (apiRes.status === 200) {
                        const token = apiRes.data.data;
                        const userDetails = jwtDecode(token); // auto handles atob safely
                        // Check login access logic, if needed
                        if (userDetails.status === 0) {
                            dispatch(setAlert({
                                title: 'Error',
                                subtitle: 'Your account is not yet verified. Please try again later.',
                                type: 'error',
                                active: true
                            }));
                        } else if(userDetails.status === 1 || userDetails.status === 6){
                            localStorage.setItem('token', token);
                            API.get(`/user/getUserDetailsById/${userDetails.id}`).then((res) => {
                                dispatch(setUserDetails(res.data.data));
                            })
                            dispatch(setToken(token));
                            dispatch(setLoggedIn(true));
                            history.push('/home');
                        } else{
                            dispatch(setAlert({
                                title: 'Error',
                                subtitle: 'Account not found',
                                type: 'error',
                                active: true
                            }));
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    if (err.response) {
                        if (err.response.status === 401) {
                            dispatch(setAlert({
                                title: 'Error',
                                subtitle: `${err.response.data.error}`,
                                type: 'error',
                                active: true
                            }));
                        } else {
                            dispatch(setAlert({
                                title: 'Error',
                                subtitle: `${err.response.data.error}`,
                                type: 'error',
                                active: true
                            }));
                        }
                    } else {
                        dispatch(setAlert({
                            title: 'Error',
                            subtitle: 'Network error. Please check your connection.',
                            type: 'error',
                            active: true
                        }));
                    }
                });
            } catch (err) {
                console.log(err)
            }
        }
    })

    return (
        <motion.div className="min-h-screen w-full flex flex-col">
            <TopBar/>
            <motion.div className="h-full w-full flex flex-row justify-between gap-2">
                <div className="w-full lg:w-1/2 flex flex-col justify-center items-start py-5 md:py-0 lg:px-20">
                    <h1 className="text-2xl font-bold text-primeColor mb-4 px-5">{t('Welcome Back!')}</h1>
                    <p className="text-black mb-6 px-5">{t('Login to get unlimited access and get your groom/bride')}</p>
                    <motion.div className="grid grid-cols-1 w-full gap-5">
                        <FieldInput outerInjectClass={'w-full'} label={t('User Name')} fieldProps={loginForm.getFieldProps('userName')} fieldHelper={loginForm.getFieldHelpers('userName')} fieldMeta={loginForm.getFieldMeta('userName')} edit={true} dataLoaded={true} />
                        <FieldInput type="password" outerInjectClass={'w-full'} label={t('Password')} fieldProps={loginForm.getFieldProps('password')} fieldHelper={loginForm.getFieldHelpers('password')} fieldMeta={loginForm.getFieldMeta('password')} edit={true} dataLoaded={true} />
                        <motion.div className="w-full flex flex-row px-5 justify-between">
                                {/* <motion.div className="w-full flex flex-row justify-start items-center">
                                    <input type="checkbox" className="mx-2" />
                                    <p>{t('Remember Me')}</p>
                                </motion.div> */}
                            <motion.div className="text-md w-full cursor-pointer text-primeColor flex flex-row justify-end font-bold" onClick={()=>history.push('/forgotPassord')}>
                                {t('Forgot Password?')}
                            </motion.div>
                        </motion.div>
                        <Button type="primary" injectClass={'flex items-center text-center justify-center flex-row w-full'} onClick={() => loginForm.submitForm()}>
                            <FiLogIn /> &nbsp;{t('Login')}</Button>
                        <motion.div className="flex flex-row w-full justify-start px-2">
                            <motion.div className="bg-[green] text-white px-4 py-1 rounded-full font-bold cursor-pointer" onClick={() => history.push('/auth/register')}>
                                <p >{t('Create New Account')}</p>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </div>
                <div className="hidden lg:flex w-1/2 h-screen relative">
                    <img
                        src={loginSide}
                        alt="Login Side"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-4 left-4 w-full items-center justify-center flex flex-col rounded-md  p-4">
                        <div className="bg-primeColor w-fit px-2 py-2">
                            <img src={logo} />
                        </div>
                        <p className="text-gray-700">{t('Kallar thirumana sevai')}</p>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    )
}

export default Login